import {_} from 'lodash';
import {nsFa} from "../../fa/fn";
import {IDialogButton, IDialogOptionsConfirm} from "../index";
import i = nsFa.i;
import basicHtml from './basic.html?raw';

export let template = basicHtml;

export class viewModel {

    private cancelButton: IDialogButton | null;
    private confirmButton: IDialogButton | null;

    constructor(private params: IDialogOptionsConfirm) {
        this.cancelButton = this.prepareButton(params.buttons?.cancel, {
            cls: 'btn-action',
            label: `${i('fa-ban')} ((cancel))`,
        });
        this.confirmButton = this.prepareButton(params.buttons?.confirm, {
            cls: 'btn-primary btn-action',
            label: `${i('fa-check')} ((ok))`,
        });
    }

    private prepareButton(button: boolean | IDialogButton | undefined, defaultButton: IDialogButton): IDialogButton | null {
        switch (button) {
            case true:
                return defaultButton;
            case false:
                return null;
            default:
                return _.defaults(button, defaultButton);
        }
    }

}
